var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sections"},[_c('SLSectionContent',{attrs:{"id":_vm.index,"section":_vm.section.section}}),_c('SLSectionStrategy',{attrs:{"id":_vm.index,"section":_vm.section.section}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }